import * as Redux from 'redux';
import { REGISTER_STAFF, UPDATE_STAFF, DELETE_STAFF } from './Constants';
import { StaffsActionTypes, StaffRequest } from './Types';
import { ReduxPromiseAction, SimpleResponse } from '../app/app.types';
import { Authority } from '../account/Types';
import { callApi } from '../util/ApiCaller';
import { passwordEncode } from '../util/auth.util';
import { pickAuthOrImpersonationToken } from '../util/token.util';

export const registerStaffAccount: Redux.ActionCreator<
  ReduxPromiseAction<
    StaffsActionTypes, SimpleResponse<{}>
  >
> = (staffRequest: StaffRequest): ReduxPromiseAction<StaffsActionTypes, SimpleResponse<{}>> => ({
  type: REGISTER_STAFF,
  payload: callApi(
    process.env.REACT_APP_API + '/account/staff',
    true,
    {
      method: 'POST',
      headers: {
        'Authorization': pickAuthOrImpersonationToken(),
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        firstName: staffRequest.firstName,
        lastName: staffRequest.lastName,
        email: staffRequest.email,
        password: passwordEncode(staffRequest.email, staffRequest.password),
        phone: staffRequest.phone,
        authorities: transformToMap(staffRequest.authorities)
      })
    }
  )
});

export const updateStaffAccount: Redux.ActionCreator<
  ReduxPromiseAction<
    StaffsActionTypes, SimpleResponse<{}>
  >
> = (staffRequest: StaffRequest): ReduxPromiseAction<StaffsActionTypes, SimpleResponse<{}>> => ({
  type: UPDATE_STAFF,
  payload: callApi(
    process.env.REACT_APP_API + '/account',
    true,
    {
      method: 'PATCH',
      headers: {
        'Authorization': pickAuthOrImpersonationToken(),
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: staffRequest.id,
        firstName: staffRequest.firstName,
        lastName: staffRequest.lastName,
        email: staffRequest.email,
        password: staffRequest.password === '' ? null : passwordEncode(staffRequest.email, staffRequest.password),
        phone: staffRequest.phone,
        authorities: transformToMap(staffRequest.authorities)
      })
    }
  )
});

export const deleteStaffAccount: Redux.ActionCreator<
  ReduxPromiseAction<
    StaffsActionTypes, SimpleResponse<{}>
  >
> = (staffRequest: StaffRequest): ReduxPromiseAction<StaffsActionTypes, SimpleResponse<{}>> => ({
  type: DELETE_STAFF,
  payload: callApi(
    process.env.REACT_APP_API + '/account',
    true,
    {
      method: 'DELETE',
      headers: {
        'Authorization': pickAuthOrImpersonationToken(),
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: staffRequest.id,
        email: staffRequest.email
      })
    }
  )
});

function transformToMap(authorities: Array<Authority>): {} {
  const temp = {};
  authorities.map((a: Authority) => temp[a.feature] = a.permission);
  return temp;
}



// WEBPACK FOOTER //
// ./src/staff/Actions.tsx